var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columnarEcharts"},[_c('div',{style:({width: '100%', 'height': _vm.height}),attrs:{"id":_vm.echarts}})])}
var staticRenderFns = []

export { render, staticRenderFns }